'use client';

import { useEffect, useState } from 'react';

type DatapointsTickerProps = {
  total: number;
  perSecond: number;
  computedAtMs: number;
};

// Extrapolates the datapoint total from its server-side snapshot at the
// reported ingest rate, so the number ticks between refetches without
// extra API load. Initial state matches the server-rendered value to
// avoid a hydration mismatch.
export default function DatapointsTicker({ total, perSecond, computedAtMs }: DatapointsTickerProps) {
  const [nowMs, setNowMs] = useState(computedAtMs);

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const id = window.setInterval(() => setNowMs(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const elapsedSeconds = Math.max(0, (nowMs - computedAtMs) / 1000);
  const displayed = Math.floor(total + perSecond * elapsedSeconds);

  return <span className="tabular-nums">{displayed.toLocaleString('en-US')}</span>;
}
